import * as React from "react";
import { FormControl, FormControlProps } from "react-bootstrap";

export type InputNumberProps = Omit<FormControlProps, "onChange" | "value"> & {
	placeholder?: string;
	value: number;
	onChange: (value: number) => void;
	error?: string;
};
export const InputNumber = React.memo((props: InputNumberProps) => {
	const { onChange, error, ...iProps } = props;
	const onChangeEvent = React.useCallback<FormControlProps["onChange"]>(
		(e) => {
			const tmp = Number(e.target.value);
			if (isNaN(tmp) || e.target.value === "") return onChange(undefined);
			onChange(tmp);
		},
		[onChange],
	);
	return (
		<>
			<FormControl {...iProps} onChange={onChangeEvent} isInvalid={!!error} />
			{!!error && <FormControl.Feedback type={"invalid"}>{error}</FormControl.Feedback>}
		</>
	);
});
